
import React, { Component, PropTypes } from 'react';
import $ from "jquery";


import ClassNames from 'classnames';
import AutoVideo from './AutoVideo';
import PageLoader from "./PageLoader";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import DelayChain from "../lib/DelayChain";
import Nav from "./Nav.js";
import GalleryOverlay from "./GalleryOverlay.js";
import Pages from "./Pages";


export default class Container extends Component {


  constructor(props) {
    super(props);

    this.introDc = new DelayChain;
    this.pageDc = new DelayChain;
    this.navDc = new DelayChain;

    this.state = {
      pageLoaded: false,
      introPhase: "unloaded",
      scrollLeft: 0,
      currPage: 0,
      prevPage: null,
      pageTransPhase: null,
      galleryItems: [],
      initialGalleryIndex: 0,
      navOpenPhase: "closed",
      marshmallowPhase: null
    }

  }

  getChildContext() {
    return {
      openGallery: (gallery, index) => {
        // Create a new object so the GalleryOverlay component can tell when we have called
        // this function
        let newGallery = gallery.slice();
        this.setState({
          galleryItems: newGallery,
          initialGalleryIndex: index
        })

      }
    };
  }
  /*
  componentDidMount() {
    // Simulates loader
    setTimeout(()=>{
      this.onPageLoad();
    }, 10000);
  }
*/
  onPageLoad() {
/*
    this.setState({
      pageLoaded: true,
      introPhase: "finish"
    });

    this.introDc.delay(1, ()=>{
      this.setState({
        introPhase: null
      });
    })

    return;

*/
    this.setState({
      pageLoaded: true
    });

    this.introDc.delay(1, ()=>{
      this.setState({
        introPhase: "video"
      });
    }).delay(5500, ()=>{
      this.setState({
        introPhase: "logo-appear"
      });
    }).delay(500, ()=>{
      this.setState({
        introPhase: "background-appear",
        marshmallowPhase: "start"
      });
    }).delay(1000, ()=>{
      this.setState({
        introPhase: "logo-shrink",
        marshmallowPhase: "enter"
      });
    }).delay(1000, ()=>{
      this.setState({
        introPhase: "logo-fade"

      });
    }).delay(200, ()=>{
      this.setState({
        introPhase: "finish"
      });
    }).delay(3000, ()=>{
      this.setState({
        introPhase: null
      });
    }).delay(1000, () =>{
      this.setState({
        marshmallowPhase: "finished"
      });
    });

  }

  handleKeyPress(e) {

    let vw = window.innerWidth;

    this.setState({
      scrollLeft: this.state.scrollLeft - vw
    });
    return;

    switch (e.keyCode) {
      case 39:
        this.setState({
          scrollLeft: this.state.scrollLeft - 500
        });
        return;
      case 37:
        this.setState({
          scrollLeft: this.state.scrollLeft + 500
        });
        return;
    }
  };


  getTransformCss(scrollLeft) {
    return {
      left: scrollLeft
    }
  }

  toggleNav() {
    if (this.state.navOpenPhase === "closed" || this.state.navOpenPhase === "closing") {
      this.openNav();
    }
    else if (this.state.navOpenPhase === "open" || this.state.navOpenPhase === "opening") {
      this.closeNav();
    }
  }

  openNav() {
    this.navDc.cancel();
    // Open it
    this.setState({
      navOpenPhase: "opening"
    });

    this.navDc.delay(1200, ()=>{
      this.setState({
        navOpenPhase: "open"
      });
    });
  }

  closeNav() {
    this.navDc.cancel();
    // Close it
    this.setState({
      navOpenPhase: "closing"
    });

    this.navDc.delay(200, ()=>{
      this.setState({
        navOpenPhase: "closed"
      });
    });
  }

  navTo(index) {
    let curr = this.state.currPage;

    if (index === curr) {
      return;
    }

    this.pageDc.cancel();

    this.closeNav();

    this.setState({
      pageTransPhase: "start"
    });
    this.pageDc.delay(1, ()=>{
      this.setState({
        currPage: index,
        prevPage: curr,
        pageTransPhase: "moving"
      });
    }).delay(1000, ()=>{
      this.setState({
        pageTransPhase: "finish"
      });
    }).delay(1, ()=>{
      this.setState({
        pageTransPhase: null
      });
    })
  }

  logoClick(e) {
    e.preventDefault();
    this.navTo(0);
  }

  componentDidUpdate(prevProps, prevState) {

    if (!prevProps.hasLoaded && this.props.hasLoaded) {
      this.onPageLoad();
    }

    if (prevState.pageTransPhase !== this.state.pageTransPhase) {
      switch (this.state.pageTransPhase) {
        case "start":
          $(".page--curr").css({
            "transform": "translateY(" + (-window.scrollY) +"px)"
          });
          window.scrollTo(0, 0);
          return;
        case "finish":
          $(".page--prev").css({
            "transform": "translateY(0px)"
          });
          return
      }
    }
  }

  render() {
    let { pages, menu } = this.props;
    let { introPhase, pageLoaded, currPage, prevPage, pageTransPhase, navOpenPhase, marshmallowPhase } = this.state;
    let classnames = ClassNames({
      'main-wrapper': true
    });

    let vw = window.innerWidth;
    let plxLyr1ScrollLeft = scrollLeft * 0.4;
    let scrollLeft = (-currPage * 100) + "vw";

    classnames = classnames + " main-wrapper-intro-phase--" + introPhase;
    classnames = classnames + " main-wrapper-page-phase--" + pageTransPhase;
    classnames = classnames + " main-wrapper-curr--" + currPage;
    classnames = classnames + " main-wrapper-nav--" + navOpenPhase;
    classnames = classnames + " main-wrapper-marshmallow--" + marshmallowPhase;

    return (
      <div className={classnames}>
        <div className="nav-trigger" onClick={this.toggleNav.bind(this)}>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>


        <div className="logo-main">
          <a href="/" onClick={this.logoClick.bind(this)}>
            <img src={window.STATIC_URL + '/img/lorax-logo-white.png'} />
          </a>
        </div>
        <Nav navItems={menu.items} pages={pages} navTo={this.navTo.bind(this)} pageIndex={currPage} />
        <Pages pages={pages} currPage={currPage} prevPage={prevPage} navTo={this.navTo.bind(this)} />
        {

          (introPhase !== null && introPhase !== "finish") ?
            (
              <div>
                <div className="intro-logo-big">
                  <img src={window.STATIC_URL + '/img/lorax-logo-orange.png'} />
                </div>
                <div className="intro-video">
                  <AutoVideo src={window.STATIC_URL + "/video/lorax-intro-saturated-final.mp4"} isPlaying={introPhase === "video"}/>
                </div>
              </div>
            )
          :
            null
        }

        <GalleryOverlay
          items={this.state.galleryItems}
          initialIndex={this.state.initialGalleryIndex}
        />
      </div>
    );
  }
}


Container.childContextTypes = {
  openGallery: React.PropTypes.func
}
